import { useRouter } from 'next/router';

/** Yields an event handler to open the provided `href` either in this window or a new tab, depending on whether the Cmd or Ctrl key is down, emulating the behavior of native anchor tags. */
export const useOpenPage = () => {
  const router = useRouter();
  const handleOpenPage = (
    event: Pick<React.MouseEvent, 'metaKey' | 'ctrlKey'>,
    href: string,
    query?: Record<string, string>,
  ) => {
    // Emulate the behavior of a native anchor tag to open in a new tab
    if (event.metaKey || event.ctrlKey) {
      const queryString = query ? `?${new URLSearchParams(query).toString()}` : '';
      window.open(`${href}${queryString}`, '_blank');
      return;
    }
    router.push({ pathname: href, query: query ?? router.query });
  };
  return handleOpenPage;
};
